import { createReducer, on } from '@ngrx/store';
import { usersActions } from '../actions/users.actions';
import { User } from '../models';

export interface UsersState {
    loaded: boolean | null;
    loading: boolean | null;
    users: User[];
}

export const initialState: UsersState = {
    loaded: null,
    loading: null,
    users: [],
};

export const usersReducer = createReducer(
    initialState,
    on(
        usersActions.getUsers,
        (state): UsersState => ({
            ...state,
            loaded: null,
        }),
    ),
    on(
        usersActions.getUsersSuccess,
        (state, payload): UsersState => ({
            ...state,
            loaded: true,
            users: payload.users,
        }),
    ),
    on(
        usersActions.getUsersError,
        (state): UsersState => ({
            ...state,
            loaded: false,
        }),
    ),
    on(
        usersActions.clear,
        (): UsersState => ({
            ...initialState,
        }),
    ),
);
